export function formatWalletId(id: `0x${string}`) {
 return `${id?.slice(0, 6)}...${id?.slice(id.length - 4, id.length)}`
}